import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

export const getScheduleTranslation = api(async function getScheduleTranslation({ scheduleId, language }) {
    return query(
        gql`
            query GetScheduleTranslation($scheduleId: String!, $language: String!) {
                getScheduleTranslation(scheduleId: $scheduleId, language: $language) {
                    title
                    intro {
                        content
                        note
                    }
                    tasks
                    labels
                    _meta {
                        language
                        languageName
                        translatedAt
                        allVerified
                        status
                        error
                    }
                }
            }
        `,
        { scheduleId, language },
        { returns: "getScheduleTranslation" }
    )
})
